import { Component } from '@angular/core';
import { DialogBaseViewComponent } from '@sb/library/base';

@Component({
    selector: 'lib-unsaved-form-changes-dialog',
    templateUrl: './unsaved-form-changes-dialog.component.html'
})
export class UnsavedFormChangesDialogComponent extends DialogBaseViewComponent<boolean> {

    get hasSaveMethod(): boolean {
        return this.data;
    }
}
